import { DEFAULT_APP_INFO } from 'mobile_web/modules/settings/functions'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import { ScannerItemType } from 'mytours-read-common'
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import ScannerComponent from '../components/Scanner'

const ScannerRoute: React.FC<RouteComponentProps> = props => (
	<ScannerComponent itemType={ScannerItemType.App} itemId={Number(DEFAULT_APP_INFO.projectId)} {...props} />
)

export default WithContainerRoute(ScannerRoute)
